
// import request from "@/utils/request";
import axios from "axios";
// 不同环境不同地址
const apis = {
  production: 'https://www.csrsxxzx.cn', // 线上地址 (生产环境)
  development: 'http://localhost:8084', // 本地 (开发环境)
}
// ajax请求设置
const ajax = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? apis.production : apis.development
})
// 封装post请求
export const postRequest = (url, params) => {
  return ajax({
    method: 'post',
    url: `/api${url}`,
    data: params
  })
}
// 获取仲裁信息
export const postScreen = (url, params) => {
  return ajax({
    method: 'post',
    url: `/api${url}`,
    data: params
  })
}
// 获取职位信息
export const AllPost = (url, params) => {
  return ajax({
    method: 'post',
    url: `/api${url}`,
    data: params
  })
}